import { useState } from "react";
import { WorkflowAssistant } from "@/components/WorkflowAssistant";
import Navigation from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { NoIndex } from "@/components/NoIndex";

const WorkflowAssistantPage = () => {
  const [workflowId, setWorkflowId] = useState("");
  const [domainKey, setDomainKey] = useState("");
  const [isConfigured, setIsConfigured] = useState(false);
  const { toast } = useToast();

  const handleConfigure = () => {
    if (!workflowId.trim() || !domainKey.trim()) {
      toast({
        title: "Missing Information",
        description: "Please enter both Workflow ID and Domain Key",
        variant: "destructive",
      });
      return;
    }
    setIsConfigured(true);
    toast({
      title: "Configuration Saved",
      description: "Your workflow assistant is now ready to use!",
    });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <NoIndex />
      <Navigation />
      <main className="flex-grow container mx-auto px-4 py-16">
        {!isConfigured ? (
          <div className="max-w-2xl mx-auto">
            <Card>
              <CardHeader>
                <CardTitle>Configure Workflow Assistant</CardTitle>
                <CardDescription>
                  Enter your workflow credentials to get started
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="workflowId">Workflow ID</Label>
                  <Input
                    id="workflowId"
                    placeholder="wf_68e5aa7fd8148190a647545b4b963a65024f91f3422841f1"
                    value={workflowId}
                    onChange={(e) => setWorkflowId(e.target.value)}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="domainKey">Domain Key</Label>
                  <Input
                    id="domainKey"
                    placeholder="domain_pk_68e5ab9558848190aa3514e6754e197302829ea0b2ed8fc6"
                    value={domainKey}
                    onChange={(e) => setDomainKey(e.target.value)}
                  />
                </div>
                <Button onClick={handleConfigure} className="w-full">
                  Start Assistant
                </Button>
              </CardContent>
            </Card>
          </div>
        ) : (
          <div className="space-y-4">
            <Button
              variant="outline"
              onClick={() => setIsConfigured(false)}
              className="mb-4"
            >
              ← Change Configuration
            </Button>
            <WorkflowAssistant workflowId={workflowId} domainKey={domainKey} />
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default WorkflowAssistantPage;
